import script from "./AllRocks.vue?vue&type=script&setup=true&lang=js"
export * from "./AllRocks.vue?vue&type=script&setup=true&lang=js"

import "./AllRocks.vue?vue&type=style&index=0&id=c564cc58&lang=css&scoped=true"

import exportComponent from "/Users/lulua/Documents/lupanalua_oficial+dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c564cc58"]])

export default __exports__